import { HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { User } from './global-functions';

const PROD_BASE_URL = 'https://luggage-api-cmviseu.microio-inovacao.com/'; 


const DEV_BASE_URL = 'https://luggage-api-cmviseu-dev.microio-inovacao.pt/';

export class ApiConfig {
    public static getUrlBase() {
        if (environment.production) {
            return PROD_BASE_URL;
        } else {
            return DEV_BASE_URL;
        }
    }

    public static getHeaderJWT() {
        const t = User.getTokenLocalStorage();
        return {
            headers: new HttpHeaders({
                Accept: 'application/json',
                Authorization: `Bearer ${t}`
            })
        };
    }


    public static getOptions() {
        return {
            headers: new HttpHeaders({
                Accept: 'application/json',
                'Content-type': 'application/json',
            })
        };
    }

    public static getOptionsJWT() {

        const t = User.getTokenLocalStorage();
        return {
            headers: new HttpHeaders({
                Accept: 'application/json',
                'Content-type': 'application/json',
                Authorization: `Bearer ${t}`
            })
        };
    }


    public static getOptionsJWTBlob() {
        const t = User.getTokenLocalStorage();
        const headers = new HttpHeaders({
            Authorization: `Bearer ${t}`,
            'Content-type': 'application/json',
        });
        return {
            headers: headers,
            responseType: 'blob' as 'json'
        };
    }

    static getOptionsReport() {
        const header = new HttpHeaders({
            'Content-type': 'application/json',
        });
        return {
            headers: header,
            responseType: 'arrayBuffer' as 'json'
        };
    }
}

export class RequestConfig {
    public static getEndPoint(endPoint: string): string {
        return ApiConfig.getUrlBase() + endPoint;
    }
    public static getEndPointWithParams(endPoint: string, params: any[]): string {
        return this.getEndPoint(endPoint) + params.join('/');
    }
}

export class Authorizations {
}



